import { Component, inject, OnInit } from '@angular/core';
import { Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { IonIcon } from '@ionic/angular/standalone';
import { SupabaseService } from '../core/supabase.service';

@Component({
  selector: 'app-shell',
  standalone: true,
  imports: [RouterOutlet, RouterLink, RouterLinkActive, IonIcon],
  template: `
    <div class="web-shell">
      @if (menuOpen) {
        <button type="button" class="mobile-scrim" aria-label="Cerrar menú" (click)="menuOpen=false"></button>
      }
      <aside class="sidebar" [class.is-open]="menuOpen" aria-label="Navegación principal">
        <div class="brand">
          <div class="brand-mark"><ion-icon name="water-outline"></ion-icon></div>
          <div class="brand-copy"><strong>Monitoreo de Dunas</strong><span>Facultad de Ciencias Marinas</span></div>
          <button type="button" class="side-close" aria-label="Cerrar menú" (click)="menuOpen=false"><ion-icon name="close-outline"></ion-icon></button>
        </div>
        <nav class="side-nav" aria-label="Secciones">
          <a routerLink="/dashboard" routerLinkActive="active" (click)="menuOpen=false"><ion-icon name="grid-outline"></ion-icon> Panel general</a>
          <a routerLink="/proyectos" routerLinkActive="active" (click)="menuOpen=false"><ion-icon name="folder-open-outline"></ion-icon> Proyectos y transectos</a>
          <a routerLink="/registros" routerLinkActive="active" (click)="menuOpen=false"><ion-icon name="leaf-outline"></ion-icon> Registros de flora</a>
          <a routerLink="/registros/nuevo" routerLinkActive="active" (click)="menuOpen=false"><ion-icon name="add-circle-outline"></ion-icon> Nuevo registro</a>
          <a routerLink="/catalogo" routerLinkActive="active" (click)="menuOpen=false"><ion-icon name="book-outline"></ion-icon> Catálogo de especies</a>
          <a routerLink="/mapa" routerLinkActive="active" (click)="menuOpen=false"><ion-icon name="map-outline"></ion-icon> Mapa geográfico</a>
          <a routerLink="/informes" routerLinkActive="active" (click)="menuOpen=false"><ion-icon name="bar-chart-outline"></ion-icon> Informes y datos</a>
        </nav>
        <div class="sidebar-bottom">
          <div class="sidebar-user" [title]="email">
            <span class="user-avatar">{{ (email.slice(0, 1) || 'I').toUpperCase() }}</span>
            <span class="user-meta"><strong>Investigador</strong><small>{{ email }}</small></span>
          </div>
          <button type="button" class="sidebar-logout" (click)="logout()" [disabled]="signingOut">
            <ion-icon name="log-out-outline"></ion-icon>{{ signingOut ? 'Cerrando sesión…' : 'Cerrar sesión' }}
          </button>
          @if (error) {<div class="sidebar-error" role="alert">{{ error }}</div>}
        </div>
      </aside>
      <div class="workspace">
        <header class="topbar">
          <button type="button" class="mobile-menu" aria-label="Abrir menú" [attr.aria-expanded]="menuOpen" (click)="menuOpen=true"><ion-icon name="menu-outline"></ion-icon></button>
          <div class="topbar-path"><strong>Monitoreo de Dunas</strong><span>Universidad de Colima · Facultad de Ciencias Marinas</span></div>
          <div class="topbar-brand" aria-label="Identidad institucional">
            <img src="assets/logos/universidad_colima.png" alt="Universidad de Colima">
            <span class="topbar-sep"></span>
            <img src="assets/logos/facultad_ciencias_marinas.png" alt="Facultad de Ciencias Marinas">
          </div>
        </header>
        <main class="main-content"><router-outlet></router-outlet></main>
      </div>
    </div>
  `
})
export class ShellComponent implements OnInit {
  private readonly backend = inject(SupabaseService);
  private readonly router = inject(Router);
  email = '';
  error = '';
  menuOpen = false;
  signingOut = false;

  async ngOnInit(): Promise<void> {
    const { data: { session } } = await this.backend.client.auth.getSession();
    this.email = session?.user.email ?? '';
  }

  async logout(): Promise<void> {
    if (this.signingOut) return;
    this.error = '';
    this.signingOut = true;
    try {
      const { error } = await this.backend.client.auth.signOut();
      if (error) throw error;
      await this.router.navigateByUrl('/login', { replaceUrl: true });
    } catch (e) {
      this.error = e instanceof Error ? e.message : 'No se pudo cerrar sesión. Vuelve a intentarlo.';
    } finally {
      this.signingOut = false;
    }
  }
}
